<template>
  <div>
    <button class="btn-log-activity" @click="showLogActivity">
      <img src="~@/assets/icon/clock.svg" alt="clock-icon" />
      <span>Log Aktivitas</span>
    </button>
    <div
      class="modal fade"
      id="transferUnitLogModal"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <!-- Header -->
          <div class="modal-header">
            <h4 class="modal-title">Log Aktivitas</h4>

            <button type="button" class="close" data-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>

          <!-- Body -->
          <div class="modal-body">
            <div class="table-responsive log-table">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th>TANGGAL</th>
                    <th>AKTIVITAS</th>
                    <th>DIBUAT OLEH</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-if="activityLogs.length === 0">
                    <td colspan="3" class="text-center">
                      Saat ini, belum terdapat catatan log yang telah dibuat.
                    </td>
                  </tr>
                  <tr v-for="(item, index) in activityLogs" :key="index">
                    <td>{{ item.createdAt }}</td>
                    <td class="item-note">
                      {{ item.note }}
                      <span
                        v-if="item.docId"
                        @click="downloadDoc(item.docId)"
                        class="text-primary"
                        style="cursor: pointer; text-decoration: underline"
                        >Download</span
                      >
                    </td>
                    <td>{{ item.createdByName }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer">
            <button class="btn btn-outline-secondary" data-dismiss="modal">
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { alert } from "@/utils";

export default {
  name: "TransferUnitLog",
  computed: {
    ...mapGetters("rentAdjustment", {
      logs: "getVerificationLogs",
      transferUnitId: "getId",
    }),
    activityLogs() {
      if (!this.logs || !this.logs.transferUnitActivityLog) {
        return [];
      }

      return this.logs.transferUnitActivityLog.map((log) => ({
        docId: this.extractNumberFromLogNote(log.activity),
        createdAt: log.createdAt,
        note: log.activity.replace(/<\d+>/g, "").trim(),
        createdByName: log.createdByName,
      }));
    },
  },
  methods: {
    ...mapActions("rentAdjustment", ["getVerificationLog"]),
    extractNumberFromLogNote(text) {
      const match = text.match(/<(\d+)>/);
      return match ? Number(match[1]) : null;
    },
    async downloadDoc(docId) {
      const response = await this.$http.get(
        process.env.DOWNLOAD_UPLOADED_DOC_TRANSFER_UNIT + `/${docId}`,
        {
          responseType: "blob",
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `document_${docId}.zip`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        await alert().fire({
          icon: "error",
          title: "Gagal Mendownload Dokumen",
          text:
            response.message || "Terjadi kesalahan saat mendownload dokumen.",
        });
      }
    },
    async showLogActivity() {
      const response = await this.getVerificationLog({
        transferUnitId: this.transferUnitId,
        type: "lease",
      });
      if (!response.isSuccess) {
        return alert().fire({
          icon: "error",
          title: "Gagal Mendapatkan Log Aktivitas",
          text: response.message,
        });
      }
      $("#transferUnitLogModal").modal("show");
    },
  },
};
</script>
<style scoped>
.modal-content {
  border: none;
  border-radius: 16px;
}

.modal-header {
  padding: 24px;
}

.modal-body {
  padding: 24px;
}

.modal-footer {
  padding: 16px 24px;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #374151;
}

.log-table {
  border: 1px solid #d9dee7;
  border-radius: 6px;
  max-height: 200px;
  overflow-y: auto;
}

thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}

.log-table table {
  margin: 0;
}

.log-table th {
  background: #f8fafc;
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  border-top: none;
}

.log-table td {
  font-size: 14px;
  vertical-align: top;
}

th:nth-child(2) {
  width: 50%;
}

.btn-outline-secondary {
  border-radius: 8px;
  color: #2e3646;
  font-size: 16px;
  padding: 10px 20px;
  font-weight: 600;
  border: 1px solid #cfd3d9;
  background-color: #ffffff;
}

.btn-outline-secondary:hover {
  background-color: #ffffff;
}

.btn-log-activity {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  background-color: #ffffff;
  border: 1px solid #d1d9e2;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #2e3646;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none !important;
}

.btn-log-activity:hover {
  background-color: #f8f9fa;
}

.btn-log-activity i {
  width: 20px;
  height: 20px;
}

.item-note::first-letter {
  text-transform: uppercase;
}
</style>


// WEBPACK FOOTER //
// src/components/RentAdjustment/CustomComponent/TransferUnitLog.vue